var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8715 3.31202C19.8715 1.55425 18.5784 0.14023 16.9805 0.14023C14.8162 0.0390613 12.6089 0 10.3531 0H9.64989C7.39961 0 5.18839 0.0390614 3.02406 0.140621C1.43011 0.140621 0.136974 1.56246 0.136974 3.32022C0.039305 4.71042 -0.00210647 6.10101 0.000237572 7.49159C-0.00366917 8.88218 0.0406073 10.2741 0.133067 11.6673C0.133067 13.425 1.4262 14.8508 3.02015 14.8508C5.29387 14.9562 7.6262 15.0031 9.99759 14.9992C12.3729 15.007 14.6987 14.9575 16.975 14.8508C18.5729 14.8508 19.866 13.425 19.866 11.6673C19.9598 10.2728 20.0028 8.88218 19.9989 7.48769C20.0077 6.0971 19.9653 4.70521 19.8715 3.31202ZM8.0872 11.3235V3.64795L13.752 7.48378L8.0872 11.3235Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5bcc5068957d60b64505e22c0ec45123.svg";
export { ForwardRef as ReactComponent };